(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-products-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-type="collection-category-nav"]');
    if (!section) return;

    var categoriesDataEl = section.querySelector('[data-categories-json]');
    if (!categoriesDataEl) return;

    var categoriesData;
    try {
      categoriesData = JSON.parse(categoriesDataEl.textContent);
    } catch (e) {
      console.error('[CategoryNav] Failed to parse categories JSON', e);
      return;
    }

    var categories = categoriesData.categories || [];
    if (categories.length === 0) return;

    // Live collection handle -> image_url map, used as a fallback when the
    // static menu-*.json data has an empty imageUrl (e.g. image added after
    // the static file was generated/exported).
    var collectionImageMap = {};
    var collectionImagesEl = section.querySelector('[data-collection-images-json]');
    if (collectionImagesEl) {
      try {
        collectionImageMap = JSON.parse(collectionImagesEl.textContent) || {};
      } catch (e) {
        console.error('[CategoryNav] Failed to parse collection images JSON', e);
      }
    }

    function getCollectionHandleFromUrl(url) {
      if (!url) return '';
      // Strip query/hash and trailing slash, then take the last path segment
      var clean = url.split('?')[0].split('#')[0].replace(/\/$/, '');
      var segments = clean.split('/');
      return segments[segments.length - 1] || '';
    }

    function resolveImageUrl(item) {
      if (item.imageUrl) return item.imageUrl;
      var handle = getCollectionHandleFromUrl(item.url);
      return (handle && collectionImageMap[handle]) || '';
    }

    // Data cache for loaded menus
    var menuCache = {};
    
    var wrapper = section.querySelector('.collection-category-nav__wrapper');
    var sidebar = section.querySelector('[data-sidebar]');
    var categoryList = section.querySelector('[data-category-list]');
    var categoryButtons = section.querySelectorAll('[data-category-button]');
    var collectionsGrid = section.querySelector('[data-collections-grid]');
    var backBar = section.querySelector('[data-back-bar]');
    var backButton = section.querySelector('[data-back-button]');
    var currentTitleEl = section.querySelector('[data-current-title]');
    var loadingEl = section.querySelector('[data-loading]');

    var assetUrlBase = section.getAttribute('data-asset-url-base') || '/assets/';
    var productsText = section.getAttribute('data-products-text') || 'products';
    var noSubcategoriesText = section.getAttribute('data-no-subcategories-text') || 'No subcategories found';
    var loadingText = section.getAttribute('data-loading-text') || 'Loading...';

    var currentBlockId = categories[0].blockId;
    var currentMenuHandle = categories[0].menuHandle;
    var currentLevel2Data = null;
    var currentLevel2Index = -1;

    function getCategoryByBlockId(blockId) {
      return categories.find(function(cat) {
        return cat.blockId === blockId;
      });
    }

    function showLoading() {
      collectionsGrid.innerHTML = '<div class="collection-category-nav__loading" data-loading><span class="collection-category-nav__loading-spinner"></span><span>' + loadingText + '</span></div>';
    }

    function showError(message, retryFn) {
      collectionsGrid.innerHTML = '<div class="collection-category-nav__error"><p>' + message + '</p><button class="collection-category-nav__error-retry" data-retry>Retry</button></div>';
      var retryBtn = collectionsGrid.querySelector('[data-retry]');
      if (retryBtn && retryFn) {
        retryBtn.addEventListener('click', retryFn);
      }
    }

    function fetchMenuData(menuHandle) {
      return new Promise(function(resolve, reject) {
        // Check cache first
        if (menuCache[menuHandle]) {
          resolve(menuCache[menuHandle]);
          return;
        }

        // URL format: {assetUrlBase}menu-{menuHandle}.json
        var url = assetUrlBase + 'menu-' + menuHandle + '.json';
        
        fetch(url)
          .then(function(response) {
            if (!response.ok) {
              throw new Error('Menu file not found: menu-' + menuHandle + '.json');
            }
            return response.json();
          })
          .then(function(data) {
            // Cache the result
            menuCache[menuHandle] = data;
            resolve(data);
          })
          .catch(reject);
      });
    }

    function createCollectionCard(item) {
      var card = document.createElement('div');
      card.className = 'collection-category-nav__collection-card';
      card.setAttribute('data-collection-card', '');
      card.setAttribute('data-url', item.url);
      card.setAttribute('data-title', item.title);

      var imageHtml = '';
      var resolvedImageUrl = resolveImageUrl(item);
      if (resolvedImageUrl) {
        imageHtml = '<img src="' + resolvedImageUrl + '" alt="' + item.title + '" class="collection-category-nav__collection-image" loading="lazy">';
      } else {
        imageHtml = '<div class="collection-category-nav__collection-placeholder"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/><path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v.1s.1 0 .2-.1h6.7c.5 0 .8-.4.8-.8v-75.5c0-.4-.4-.8-.8-.8h-112c-.4 0-.8.4-.8.8v75.5c0 .4.3.8.8.8zm6.2-73.6h36.5l-36.5 50.8v-50.8zm48.4 0h7.3l-43.4 60.7c0 .1-.1.3-.1.3h-.9l37.1-51.6v51.6h-7.3l28.2-39.3v39.3h-.9c0-.1-.1-.2-.1-.3l-27.3-38.1 7.4-22.6zm46.2 0h6.9l-42.2 58.8v-4.4l33.1-46.1v51.6H293l21.4-29.8v29.8h-3.2l.1-59.9zm-69.3 0h7.4l-7.4 22.4v-22.4zm67.3 62.5l-39.4-54.9h12.6l34.1 47.5v7.4h-7.3z"/></svg></div>';
      }

      var countText = item.productsCount > 0 ? item.productsCount + ' ' + productsText : '';

      card.innerHTML = 
        '<div class="collection-category-nav__collection-image-wrapper">' + imageHtml + '</div>' +
        '<div class="collection-category-nav__collection-info">' +
          '<h3 class="collection-category-nav__collection-title">' + item.title + '</h3>' +
          (countText ? '<span class="collection-category-nav__collection-count">' + countText + '</span>' : '') +
        '</div>';

      return card;
    }

    function renderLevel2FromData(data) {
      currentLevel2Data = data;
      collectionsGrid.innerHTML = '';

      if (!data.level2 || data.level2.length === 0) {
        var emptyEl = document.createElement('div');
        emptyEl.className = 'collection-category-nav__empty';
        emptyEl.innerHTML = '<p>' + noSubcategoriesText + '</p>';
        collectionsGrid.appendChild(emptyEl);
      } else {
        // Use DocumentFragment for better performance with many items
        var fragment = document.createDocumentFragment();
        
        data.level2.forEach(function(item, index) {
          var card = createCollectionCard(item);
          card.setAttribute('data-level2-index', index);
          
          card.addEventListener('click', function() {
            var idx = parseInt(this.getAttribute('data-level2-index'), 10);
            var level2Item = data.level2[idx];
            
            if (level2Item.hasChildren && level2Item.level3 && level2Item.level3.length > 0) {
              showLevel3(idx);
            } else {
              window.location.href = level2Item.url;
            }
          });
          
          fragment.appendChild(card);
        });
        
        collectionsGrid.appendChild(fragment);
      }

      wrapper.classList.remove('is-full-width');
      sidebar.removeAttribute('hidden');
      backBar.setAttribute('hidden', '');
    }

    function loadAndRenderLevel2(blockId, menuHandle) {
      showLoading();
      currentBlockId = blockId;
      currentMenuHandle = menuHandle;
      currentLevel2Index = -1;

      fetchMenuData(menuHandle)
        .then(function(data) {
          renderLevel2FromData(data);
        })
        .catch(function(err) {
          console.error('[CategoryNav] Error loading menu:', err);
          showError('Failed to load categories', function() {
            loadAndRenderLevel2(blockId, menuHandle);
          });
        });
    }

    function showLevel3(level2Index) {
      if (!currentLevel2Data || !currentLevel2Data.level2) return;

      var level2Item = currentLevel2Data.level2[level2Index];
      if (!level2Item) return;

      collectionsGrid.innerHTML = '';
      currentLevel2Index = level2Index;

      if (!level2Item.level3 || level2Item.level3.length === 0) {
        var emptyEl = document.createElement('div');
        emptyEl.className = 'collection-category-nav__empty';
        emptyEl.innerHTML = '<p>' + noSubcategoriesText + '</p>';
        collectionsGrid.appendChild(emptyEl);
      } else {
        // Use DocumentFragment for better performance
        var fragment = document.createDocumentFragment();
        
        level2Item.level3.forEach(function(item) {
          var card = createCollectionCard(item);
          
          card.addEventListener('click', function() {
            window.location.href = item.url;
          });
          
          fragment.appendChild(card);
        });
        
        collectionsGrid.appendChild(fragment);
      }

      wrapper.classList.add('is-full-width');
      sidebar.setAttribute('hidden', '');
      backBar.removeAttribute('hidden');
      
      if (currentTitleEl) {
        currentTitleEl.textContent = level2Item.title;
      }
    }

    function goBackToLevel2() {
      if (currentLevel2Data) {
        renderLevel2FromData(currentLevel2Data);
      } else {
        loadAndRenderLevel2(currentBlockId, currentMenuHandle);
      }

      categoryButtons.forEach(function(btn) {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
        if (btn.getAttribute('data-block-id') === currentBlockId) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
        }
      });
    }

    categoryButtons.forEach(function(button, buttonIndex) {
      // Prefetch on hover for faster switching
      button.addEventListener('mouseenter', function() {
        var menuHandle = this.getAttribute('data-menu-handle');
        if (!menuCache[menuHandle]) {
          var url = assetUrlBase + 'menu-' + menuHandle + '.json';
          fetch(url)
            .then(function(response) {
              if (response.ok) return response.json();
            })
            .then(function(data) {
              if (data) menuCache[menuHandle] = data;
            })
            .catch(function() {});
        }
      });

      button.addEventListener('click', function() {
        var blockId = this.getAttribute('data-block-id');
        var menuHandle = this.getAttribute('data-menu-handle');
        var currentButtonIndex = buttonIndex;

        categoryButtons.forEach(function(btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });

        this.classList.add('is-active');
        this.setAttribute('aria-selected', 'true');

        loadAndRenderLevel2(blockId, menuHandle);
        
        // Prefetch adjacent menus after switching
        setTimeout(function() {
          prefetchAdjacentMenus(currentButtonIndex);
        }, 300);
      });
    });

    if (backButton) {
      backButton.addEventListener('click', goBackToLevel2);
    }

    function checkScrollEnd() {
      if (!categoryList || !sidebar) return;
      var scrollLeft = categoryList.scrollLeft;
      var scrollWidth = categoryList.scrollWidth;
      var clientWidth = categoryList.clientWidth;
      var isAtEnd = scrollLeft + clientWidth >= scrollWidth - 10;
      
      if (isAtEnd) {
        sidebar.classList.add('is-scrolled-end');
      } else {
        sidebar.classList.remove('is-scrolled-end');
      }
    }

    function checkIfScrollable() {
      if (!categoryList || !sidebar) return;
      var isScrollable = categoryList.scrollWidth > categoryList.clientWidth;
      if (!isScrollable) {
        sidebar.classList.add('is-scrolled-end');
      } else {
        sidebar.classList.remove('is-scrolled-end');
        checkScrollEnd();
      }
    }

    if (categoryList) {
      categoryList.addEventListener('scroll', checkScrollEnd, { passive: true });
      window.addEventListener('resize', function() {
        checkScrollEnd();
        checkIfScrollable();
      }, { passive: true });
    }

    // Prefetch adjacent menu data for faster switching
    function prefetchAdjacentMenus(currentIndex) {
      var prefetchIndexes = [currentIndex - 1, currentIndex + 1];
      prefetchIndexes.forEach(function(idx) {
        if (idx >= 0 && idx < categories.length) {
          var menuHandle = categories[idx].menuHandle;
          if (!menuCache[menuHandle]) {
            // Prefetch in background without blocking
            var url = assetUrlBase + 'menu-' + menuHandle + '.json';
            fetch(url)
              .then(function(response) {
                if (response.ok) return response.json();
              })
              .then(function(data) {
                if (data) menuCache[menuHandle] = data;
              })
              .catch(function() {}); // Silently fail prefetch
          }
        }
      });
    }

    // Initialize with first category
    if (categories.length > 0) {
      loadAndRenderLevel2(categories[0].blockId, categories[0].menuHandle);
      checkScrollEnd();
      checkIfScrollable();
      
      // Prefetch next category after initial load
      setTimeout(function() {
        prefetchAdjacentMenus(0);
      }, 500);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
